export default "__VITE_ASSET__BY1ujSiB__"